import React, {useCallback, useEffect} from 'react';
import './RotateCamera.css';
import { IonRange } from '@ionic/react';
import { Globals } from '../../../misc/helpers';
import { debug } from 'console';
import { Slider, Rail, Handles, Tracks } from 'react-compound-slider';
import { SliderRail, Handle, Track } from '../helpers/Slider';

const sliderStyle = {
	position: 'relative' as 'relative',
	width: '100%',
	touchAction: 'none',
};
  
const RotateCamera = (obj: any) => {
	if(typeof obj.parameters.currentValue === 'undefined') {
		obj.parameters.currentValue = 50;
	}

	const glowing = true;// obj.parameters.glowing === true;
	console.log(glowing);
	const changePositionCallback = useCallback(
		(percentage) => {
			percentage /= 100;
			if(obj.parameters.onUpdate) {
				obj.parameters.onUpdate(percentage);
			}
			obj.parameters.dispatch({
				type: 'playSequence',
				value: {
					sequenceName: 'RotateCamera',
					props: {
						sequenceProps: {
							percentage: percentage
						}
					},
					skipAnimations: Globals.skipAnimations
				}
			});
		},
		[],
	);
	const domain = [0, 99];
	const defaultValues = [50];
	const values = defaultValues.slice();

	useEffect(() => {
		changePositionCallback(obj.parameters.currentValue);
	}, []);

	return (
		<div className={`modal-disable-select rotate-camera-container ${obj.parameters.disabled ? 'disabled-container' : ''}`}>
			<div className="ui-inner-container">
				<div style={{ height: 20, width: '100%' }}>
					<Slider
						mode={1}
						step={0.1}
						domain={domain}
						rootStyle={sliderStyle}
						onUpdate={e => {
							var percentage = e[0];
							obj.parameters.currentValue = percentage;
							console.warn(percentage);
							changePositionCallback(percentage);
						}}
						values={values}
					>
						<Rail>
							{({ getRailProps }) => <SliderRail getRailProps={getRailProps} />}
						</Rail>
						<Handles>
							{({ handles, getHandleProps }) => (
								<div className="slider-handles">
									{handles.map((handle) => (
										<Handle
											key={handle.id}
											handle={handle}
											domain={domain}
											glowing={glowing}
											getHandleProps={getHandleProps}
										/>
									))}
								</div>
							)}
						</Handles>
					</Slider>
				</div>
			</div>
		</div>
	);
};

export default RotateCamera;
